import React from 'react';
import { ComponentFrame } from "../../frame/ComponentFrame";
import { SectionHeader } from "../../components/section-header/SectionHeader";
import { ItemGroup } from "../../components/item-group/ItemGroup";
import { GridLayout } from "../../components/layout/GridLayout";
import {ContactCardItem} from "../../components/item/ContactCardItem";

export class MarketingContact extends React.Component {

  render(){
    if(!this.props.contacts)
      return null;

    console.log(this.props.contacts);

    return (
      <div className={"marketing-contact-container"}>
        <ComponentFrame tag="section"
                        header={
                          <SectionHeader align="center"
                                         color="white"
                                         title="SALES OF AVIATION LIGHTS" />
                        }>
          <ItemGroup layout={ GridLayout }
                     layoutAttributes={{ center: true }}
                     item={ ContactCardItem }
                     itemStyle="" data={this.props.contacts}/>
        </ComponentFrame>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/views/contact-us/MarketingContact.js